// Verbatim port of legacy/dashboard.html's <body> inner markup (everything
// except the <script> tag itself). The container element passed to
// mountDashboard already carries the `.dashboard-root` class that scopes
// dashboard.css, so this string only holds the direct children of <body>.
//
// Note: the logo src is `/emr-logo.svg` (absolute) instead of the legacy
// relative `emr-logo.svg`, per the porting instructions — same missing-file
// fallback behavior via onerror.
export const DASHBOARD_TEMPLATE = /* html */ `
<div id="toast-root"></div>

<!-- TOPBAR -->
<header class="topbar">
  <div class="brand">
    <img src="/emr-logo.svg" alt="Imarc Forms" class="brand-logo" onerror="this.style.display='none';this.nextSibling.style.display='flex'">
    <span style="display:none;align-items:center;gap:6px;font-size:16px;font-weight:800;color:var(--brand)">
      <span style="width:28px;height:28px;background:var(--brand);border-radius:7px;display:flex;align-items:center;justify-content:center;color:#fff;font-size:13px">F</span>Imarc Forms
    </span>
  </div>
  <div class="topbar-search">
    <span class="srch-icon">🔍</span>
    <input type="text" id="search-input" placeholder="Search forms…" autocomplete="off">
  </div>
  <div class="topbar-end">
    <button class="btn" id="btn-signout">Sign out</button>
  </div>
</header>

<main class="main">
  <!-- New Form -->
  <div class="new-form-strip">
    <h2>Start a new form</h2>
    <div class="new-form-cards">
      <div class="new-form-card" id="btn-new-blank" title="Blank form">
        <div class="nfc-thumb">
          <div class="nfc-thumb-blank">＋</div>
        </div>
        <span class="nfc-label">Blank form</span>
      </div>
      <div class="new-form-card" id="btn-import" title="Import from HTML file">
        <div class="nfc-thumb">
          <div class="nfc-thumb-blank" style="font-size:22px">📥</div>
        </div>
        <span class="nfc-label">Import form</span>
      </div>
      <input type="file" id="import-file" accept=".html,.htm" style="display:none">
    </div>
  </div>

  <!-- Recent Forms -->
  <div class="section-hdr">
    <h2>Recent forms</h2>
    <select class="sort-select" id="sort-select">
      <option value="updated">Last opened ▾</option>
      <option value="title">Title A–Z</option>
      <option value="responses">Most responses</option>
    </select>
  </div>
  <div class="forms-grid" id="forms-grid"></div>
</main>

<!-- Rename Modal -->
<div class="modal-overlay" id="rename-modal" style="display:none">
  <div class="modal-box">
    <div class="modal-head">Rename form</div>
    <div class="modal-body">
      <input type="text" id="rename-input" placeholder="Form title" maxlength="120">
    </div>
    <div class="modal-foot">
      <button class="btn" id="rename-cancel">Cancel</button>
      <button class="btn primary" id="rename-ok">Rename</button>
    </div>
  </div>
</div>

<!-- Delete Confirm Modal -->
<div class="modal-overlay" id="delete-modal" style="display:none">
  <div class="modal-box">
    <div class="del-modal-icon">🗑️</div>
    <div class="del-modal-msg">
      <strong>Delete this form?</strong><br>
      All questions and responses will be permanently deleted. This cannot be undone.
    </div>
    <div class="modal-foot" style="justify-content:center;gap:12px">
      <button class="btn" id="delete-cancel">Cancel</button>
      <button class="btn danger-btn" id="delete-ok">Yes, delete</button>
    </div>
  </div>
</div>
`;
